export const EXTERNAL_IDENTIFIERS_FIELD_KEY = "case_details.case_external_identifiers";

export const WORK_QUEUE_REVIEW_SOURCE = "work-queue";

export const comparisonCurrentLabel = (caseNumber: string): string => `Current Case (${caseNumber})`;
export const comparisonSelectedLabel = (caseNumber: string): string => `Selected Case (${caseNumber})`;
